import { useEffect, useState } from "react";
import api from "../utils/axios";
import Swal from "sweetalert2";

interface SettingsData {
  aff_amount: string;
  invitee_amount: string;
  telegram_link: string;
  whatsapp_no: string;

  min_deposit: string;
  min_valid_bets: string;
  time_window: string;

  withdrawal_fee: string; // NEW
  paytypecode: string; // NEW
  deposit_turnover: string
}

const Settings = () => {
  const [settings, setSettings] = useState<SettingsData>({
    aff_amount: "",
    invitee_amount: "",
    telegram_link: "",
    whatsapp_no: "",

    min_deposit: "",
    min_valid_bets: "",
    time_window: "",

    withdrawal_fee: "",
    paytypecode: "",
    // payout_code: "",
    deposit_turnover: "",
  });
  const [loading, setLoading] = useState(false);

  /* ================= FETCH SETTINGS ================= */
  const fetchSettings = async () => {
    try {
      const res = await api.get("/getPaymentSetting");
      setSettings({
        aff_amount: res.data?.aff_amount || "",
        invitee_amount: res.data?.invitee_amount || "",
        telegram_link: res.data?.telegram_link || "",
        whatsapp_no: res.data?.whatsapp_no || "",

        min_deposit: res.data?.min_deposit || "",
        min_valid_bets: res.data?.min_valid_bets || "",
        time_window: res.data?.time_window || "",

        withdrawal_fee: res.data?.withdrawal_fee || "",
        paytypecode: res.data?.paytypecode || "",
        deposit_turnover: res.data?.deposit_turnover || "",

      });
    } catch (err) {
      console.error("Failed to load settings", err);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSettings((prev) => ({ ...prev, [name]: value }));
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post("/updatePaymentSetting", settings);
      Swal.fire({
        icon: "success",
        title: "Settings Updated",
        text: "Your settings have been successfully updated.",
      });
      fetchSettings();
    } catch (err) {
      console.error("Update failed", err);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "Failed to update settings.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-8 ">
      {/* ================= PAGE TITLE ================= */}
      <div>
        <h1 className="text-2xl font-bold text-gray-800">Settings</h1>
        <p className="text-sm text-gray-500">
          Manage affiliate commissions and support details
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-8">
        {/* ================= AFFILIATE SETTINGS ================= */}
        <div className="bg-white border rounded-2xl p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Affiliate Commission
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-sm text-gray-500">
                Affiliate Commission Amount
              </label>
              <input
                type="text"
                name="aff_amount"
                value={settings.aff_amount}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 mt-1"
                placeholder="e.g. 10"
              />
            </div>

            <div>
              <label className="text-sm text-gray-500">
                Signup Bonus Amount
              </label>
              <input
                type="text"
                name="invitee_amount"
                value={settings.invitee_amount}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 mt-1"
                placeholder="e.g. 5"
              />
            </div>
          </div>
        </div>

        {/* ================= ADMIN CONTROLS ================= */}
        <div className="bg-white border rounded-2xl p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Witdrawal Controls
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Withdrawal Fee */}
            <div>
              <label className="text-sm text-gray-500">
                Withdrawal Fee (%)
              </label>
              <input
                type="number"
                name="withdrawal_fee"
                value={settings.withdrawal_fee}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 mt-1"
                placeholder="e.g. 5"
              />
            </div>

            {/* Paytypecode Dropdown */}
            {/* <div>
              <label className="text-sm text-gray-500">FZPay Paytypecode</label>
              <select
                name="paytypecode"
                value={settings.paytypecode}
                onChange={(e) =>
                  setSettings((prev) => ({
                    ...prev,
                    paytypecode: e.target.value,
                  }))
                }
                className="w-full border rounded-lg px-3 py-2 mt-1"
              >
                <option value="">Select</option>
                <option value="15001">15001</option>
                <option value="15004">15004</option>
                <option value="15005">15005</option>
                <option value="15006">15006</option>
              </select>
            </div> */}

          </div>
        </div>

        <div className="bg-white border rounded-2xl p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Deposit turnover Controls
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Withdrawal Fee */}
            <div>
              <label className="text-sm text-gray-500">
                deposit turnover set (x2)
              </label>
              <input
                type="number"
                name="deposit_turnover"
                value={settings.deposit_turnover}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 mt-1"
                placeholder="e.g. 2"
              />
            </div>

          </div>
        </div>

        {/* ================= ADMIN CONTROLS ================= */}
        <div className="bg-white border rounded-2xl p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Admin Controls
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="text-sm text-gray-500">
                Minimum Deposit Threshold
              </label>
              <input
                type="number"
                name="min_deposit"
                value={settings.min_deposit}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 mt-1"
                placeholder="e.g. 100"
              />
            </div>

            <div>
              <label className="text-sm text-gray-500">
                Minimum Valid Bets
              </label>
              <input
                type="number"
                name="min_valid_bets"
                value={settings.min_valid_bets}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 mt-1"
                placeholder="e.g. 5"
              />
            </div>

            <div>
              <label className="text-sm text-gray-500">
                Time Window (Days)
              </label>
              <input
                type="number"
                name="time_window"
                value={settings.time_window}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 mt-1"
                placeholder="e.g. 7"
              />
            </div>
          </div>
        </div>

        {/* ================= SUPPORT SETTINGS ================= */}
        <div className="bg-white border rounded-2xl p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Support & Contact
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-sm text-gray-500">
                Telegram Support Link
              </label>
              <input
                type="text"
                name="telegram_link"
                value={settings.telegram_link}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 mt-1"
                placeholder="https://t.me/yourchannel"
              />
            </div>

            <div>
              <label className="text-sm text-gray-500">WhatsApp Number</label>
              <input
                type="text"
                name="whatsapp_no"
                value={settings.whatsapp_no}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 mt-1"
                placeholder="+91XXXXXXXXXX"
              />
            </div>
          </div>
        </div>

        {/* ================= SAVE BUTTON ================= */}
        <div className="flex justify-end">
          <button
            type="submit"
            disabled={loading}
            className="px-6 py-2 rounded-lg bg-gray-900 text-white hover:bg-gray-800 disabled:opacity-50"
          >
            {loading ? "Saving..." : "Save Settings"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Settings;
